var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "add" },
        [
          _vm._l(_vm.btn, function (item, index) {
            return [
              _vm.activeName == item.productType
                ? _c(
                    "el-button",
                    {
                      key: index,
                      attrs: {
                        type: "primary",
                        disabled: _vm.dataSource.length,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.add(item.productType)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "新增·" + _vm._s(_vm.multiLanguageDisplay(item.name))
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        _vm._l(_vm.btn, function (item, index) {
          return _c("el-tab-pane", {
            key: index,
            class: "pane-" + item.value,
            attrs: {
              label: _vm.multiLanguageDisplay(item.name),
              name: item.productType,
            },
          })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        { attrs: { data: _vm.dataSource, border: "" } },
        [
          _c("el-table-column", {
            attrs: { label: "图片/视频", width: "150", prop: "url" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.url && _vm.checkFileType(scope.row.url) == "图片"
                      ? _c("img", {
                          staticClass: "avatar",
                          attrs: { src: scope.row.url, alt: "" },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.url && _vm.checkFileType(scope.row.url) == "视频"
                      ? _c("video", {
                          staticClass: "avatar",
                          attrs: { src: scope.row.url, controls: "" },
                        })
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "描述", prop: "text" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.multiLanguageDisplay(scope.row.text)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "启用状态", prop: "status" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-switch", {
                      attrs: { "active-color": "#13ce66" },
                      on: {
                        change: function ($event) {
                          return _vm.onEnable($event, scope.row)
                        },
                      },
                      model: {
                        value: scope.row.enable,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "enable", $$v)
                        },
                        expression: "scope.row.enable",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.edit(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteItem(scope.row)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.tit,
            visible: _vm.dialogVisible,
            width: "40%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, "label-width": "80px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "启用状态" } },
                [
                  _c("el-switch", {
                    attrs: { "active-color": "#13ce66" },
                    model: {
                      value: _vm.form.enable,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "enable", $$v)
                      },
                      expression: "form.enable",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "缩略图" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "avatar-uploader",
                      attrs: {
                        headers: _vm.headers,
                        action: _vm.uploadPath,
                        "before-upload": _vm.upbefore,
                        accept: "image/jpeg,image/png,.gif,.mp4,.wmv",
                        "show-file-list": false,
                        "on-success": _vm.handleAvatarSuccess,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "tip",
                          fn: function () {
                            return [
                              _vm._v(
                                "\n            视频大小不超过10M，图片不超过800kb\n          "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _vm.form.url && _vm.checkFileType(_vm.form.url) == "图片"
                        ? _c("img", {
                            staticClass: "avatar",
                            attrs: { src: _vm.form.url },
                          })
                        : _vm.form.url &&
                          _vm.checkFileType(_vm.form.url) == "视频"
                        ? _c("div", { staticClass: "mask" }, [
                            _c("div", {
                              staticClass: "zc",
                              on: { click: _vm.upload },
                            }),
                            _vm._v(" "),
                            _c("video", {
                              staticClass: "avatar1",
                              attrs: { src: _vm.form.url, controls: "" },
                            }),
                          ])
                        : _c("i", {
                            staticClass:
                              "el-icon-plus avatar-uploader-icon avatar",
                          }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "描述" } },
                [
                  _c("MultiLanguageInp", {
                    attrs: {
                      type: "textarea",
                      "inp-data-j-s-o-n": _vm.form.text,
                    },
                    on: {
                      updateInp: function (val) {
                        return (_vm.form.text = val)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.sure()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }